import { render } from "./VInfoBlocks.vue?vue&type=template&id=40daafb8&scoped=true"
import script from "./VInfoBlocks.vue?vue&type=script&lang=js"
export * from "./VInfoBlocks.vue?vue&type=script&lang=js"

import "./VInfoBlocks.vue?vue&type=style&index=0&id=40daafb8&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40daafb8"]])

export default __exports__